import * as React from 'react';
import { FreeTextCustomFormField, CustomFormAnswer, CustomFormSelection, buildTranslator } from '../../../../amorg-common';
import { TextSaveField } from '../../../../designSystem/formField/text/TextSaveField';
import { fieldValidation } from '../../../../amorg-common/modules/fieldValidation/fieldValidation';
import { TextAreaSaveField } from '../../../../designSystem/formField/textArea/TextAreaSaveField';
import { AnswerFieldContext } from '../customFormFieldFactory';
import { CustomFormFieldHeader } from '../../[parm]/_components/CustomFormFieldHeader';
import { CustomFormFieldFooter } from '../../[parm]/_components/CustomFormFieldFooter';

type FreeTextCustomFormFieldComponentProps = AnswerFieldContext & {
    field:FreeTextCustomFormField
}
export function FreeTextCustomFormFieldComponent(props:FreeTextCustomFormFieldComponentProps):JSX.Element
{

    const translator = buildTranslator('da');

    return (
        <section>
            <CustomFormFieldHeader field={props.field} />
            {props.field.multiLine
                ? <MultiLineFreeText {...props} />
                : <SingleLineFreeText {...props} />
            }
            
            {props.field.footer &&
                <CustomFormFieldFooter text={translator(props.field.footer)} />
            }
        </section>
    );
}

function MultiLineFreeText(props:FreeTextCustomFormFieldComponentProps)
{
    const selection = props.answer.selections.find(s => s.fieldId === props.field.fieldId);

    return (
        <section>
            <TextAreaSaveField
                disabled={props.disabled}
                label={''}
                value={selection.value}
                validator={getValidator()}
                onSave={getOnSave(props.field, props.answer, props.doUpdate, props.onSubmit)}
                minRows={3}
            />
        </section>
    );
}

function SingleLineFreeText(props:FreeTextCustomFormFieldComponentProps)
{
    const selection = props.answer.selections.find(s => s.fieldId === props.field.fieldId);

    return (
        <section>
            <TextSaveField
                disabled={props.disabled}
                label={''}
                value={selection.value}
                validator={getValidator()}
                onSave={getOnSave(props.field, props.answer, props.doUpdate, props.onSubmit)}
            />
        </section>
    );
}

function getOnSave(field:FreeTextCustomFormField, answer:CustomFormAnswer, onUpdate:()=>Promise<void>, onSubmit:(selections:CustomFormSelection[])=>Promise<void>)
{
    return async (value:string, isValid:boolean) => {
        if(isValid){
            await onSubmit([{ fieldId:field.fieldId, value}]);
            onUpdate();
        }
    };
}


type Validator = (currentValue: string) => { valid: true } | { valid: false, errorMessage: string };

function getValidator():Validator
{
    return (currentValue) =>
        fieldValidation.customFormAnswer.selection.value(currentValue)
            ? { valid: true }
            : { valid: false, errorMessage: 'Ugyldig værdi' }
}